'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import Button from '../../../components/atoms/Button';
import { reportErrorToClarity } from '../../../utils/clarity';
import { OrderError } from '../../../components/icons';

export default function EventError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportErrorToClarity({ errorType: 'event-page-error', error });
  }, [error]);

  // A hard reload beats `reset()` here: the event page hydrates Redux + the SPA
  // bundle, and re-rendering the boundary alone usually reproduces the failure.
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <main className="flex min-h-[100dvh] items-center justify-center px-4 py-10 text-text-primary">
      <div className="glass-surface flex w-full max-w-md flex-col items-center gap-6 p-6 text-center sm:p-8">
        <OrderError className="w-20 h-20" />
        <div className="flex flex-col gap-2">
          <h1 className="display-sm-semibold m-0 text-text-primary">
            No pudimos cargar el evento
          </h1>
          <p className="text-md-regular m-0 text-text-secondary">
            Ocurrió un error al cargar la página del evento. Intentá de nuevo.
          </p>
        </div>
        <div className="flex w-full flex-col items-center gap-2">
          <Button variant="primary" onClick={handleRetry}>
            Reintentar
          </Button>
          <Link
            href="/"
            className="text-md-semibold flex h-11 w-full items-center justify-center rounded-3xl px-4 py-2.5 text-primary-500 transition-colors duration-200 ease-in-out hover:bg-primary-500/20"
          >
            Ir al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
